export function getTargetJobID(workReq, job, entity) {
  if (entity === 'jobDetail' || entity === 'jobDetailBvA' || entity === 'jobDetailActual') {
    return job?.jobID || 0;
  }
  return workReq?.jobs?.[0]?.jobID || 0;
}